import React from "react";
import { SvgIcon, SvgIconProps } from "@material-ui/core";
import { DATATEST } from "constants/integration";

const Panel = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} data-test={DATATEST.PROFILE.GRID_VIEW_TYPES.PANEL}>
            <path d="M10,2H1C0.4,2,0,2.4,0,3v18c0,0.6,0.4,1,1,1h9c0.6,0,1-0.4,1-1V3C11,2.4,10.6,2,10,2z" />
            <path d="M23,2h-9c-0.6,0-1,0.4-1,1v18c0,0.6,0.4,1,1,1h9c0.6,0,1-0.4,1-1V3C24,2.4,23.6,2,23,2z" />
        </SvgIcon>
    );
};

export default Panel;
